/** Shared sizing for all header controls — keeps everything visually aligned */
export const HEADER = {
  /** Standard height for all header buttons, inputs, indicators */
  HEIGHT: 32,
  /** Standard width for square icon-only buttons */
  ICON_SIZE: 32,
  /** Border radius for header controls */
  RADIUS: 6,
  /** Icon size inside buttons */
  ICON_PX: 18,
  /** Font size for labels/text in header controls */
  FONT_SIZE: 12,
} as const;
